/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentDetailsAssetAllocationViewModel } from './InvestmentDetailsAssetAllocationViewModel';
import {
    InvestmentDetailsAssetAllocationViewModelFromJSON,
    InvestmentDetailsAssetAllocationViewModelFromJSONTyped,
    InvestmentDetailsAssetAllocationViewModelToJSON,
} from './InvestmentDetailsAssetAllocationViewModel';

/**
 * 
 * @export
 * @interface InvestmentDetailsAssetSelectionViewModel
 */
export interface InvestmentDetailsAssetSelectionViewModel {
    /**
     * 
     * @type {Array<InvestmentDetailsAssetAllocationViewModel>}
     * @memberof InvestmentDetailsAssetSelectionViewModel
     */
    fundAllocationSplits?: Array<InvestmentDetailsAssetAllocationViewModel>;
}

/**
 * Check if a given object implements the InvestmentDetailsAssetSelectionViewModel interface.
 */
export function instanceOfInvestmentDetailsAssetSelectionViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvestmentDetailsAssetSelectionViewModelFromJSON(json: any): InvestmentDetailsAssetSelectionViewModel {
    return InvestmentDetailsAssetSelectionViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsAssetSelectionViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsAssetSelectionViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fundAllocationSplits': !exists(json, 'FundAllocationSplits') ? undefined : ((json['FundAllocationSplits'] as Array<any>).map(InvestmentDetailsAssetAllocationViewModelFromJSON)),
    };
}

export function InvestmentDetailsAssetSelectionViewModelToJSON(value?: InvestmentDetailsAssetSelectionViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FundAllocationSplits': value.fundAllocationSplits === undefined ? undefined : ((value.fundAllocationSplits as Array<any>).map(InvestmentDetailsAssetAllocationViewModelToJSON)),
    };
}

